export const isMobile = () => {
  return ( ( window.innerWidth <= 800 ) && ( window.innerHeight <= 800 ) );
}
